import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';

export class FloatingCtaItemComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // on mobile, tapping on a button will open it and second tap will fire onCtaClick
      // on desktop the button is opened on hover and then click will fire onCtaClick
      buttonIsClickableOnMobile: false,
    };
  }

  handleClickOutside = () => {
    this.setState({ buttonIsClickableOnMobile: false });
  };

  handleClickInside = () => {
    const { buttonIsClickableOnMobile } = this.state;
    const { isMobile, onCtaClick } = this.props;
    if (isMobile && !buttonIsClickableOnMobile) {
      this.setState({ buttonIsClickableOnMobile: true });
    } else {
      onCtaClick();
    }
  };

  render() {
    const { icon, text, disableButton, svgIcon, blueBorder, submitLoader } = this.props;
    return (
      <button
        className={`${blueBorder ? 'floating-cta-blue-border' : 'floating-cta'}`}
        type="button"
        onClick={this.handleClickInside}
        disabled={disableButton}
      >
        {svgIcon && <SvgIcon name={svgIcon} className="svg" />}
        {icon && <div className={`td-icon ${icon}`} />}
        <div className="cta-text">
          {text}
          <div className={`td-icon ${submitLoader ? 'icon-transfer-plan' : 'icon-ui-right-arrow-thick'}`} />
        </div>
      </button>
    );
  }
}

export default enhanceWithClickOutside(FloatingCtaItemComponent);
